export default function TimeSlot({ day, slotIndex, slot, removeSlot }) {
  const convertTimeToNiceTime = (hours, minutes) => {
    //input is hours in 24 hour format and minutes
    //output is in format hh:mm am/pm
    const ampm = hours >= 12 ? 'pm' : 'am';
    var hour = hours == 12 ? 12 : hours % 12;
    const minute = minutes < 10 ? '0' + minutes : minutes;
    //if hour is 0, set it to 12
    hour = hour == 0 ? 12 : hour;
    return hour + ':' + minute + '' + ampm;
  };

  return (
    <button
      id={`${day}-${slotIndex}`}
      onClick={() => removeSlot(day, slotIndex)}
      className="group col-span-1 flex cursor-pointer flex-row items-center justify-center space-x-1 rounded-lg p-1.5 duration-100 hover:bg-gray-100"
    >
      <p className="group-hover:line-through">
        {convertTimeToNiceTime(slot.h, slot.m)}
      </p>
    </button>
  );
}
